import { compose } from "redux";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import emptyState from "./emptyState";

import { IAction } from "../../../models/Action";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const { EMERGENCY_USER_LIST, DETAIL, USER, CALL_STATE } = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.EMERGENCY_REQUEST_LIST_SUCCESS]: (
    state: any,
    action: IAction
  ) => {
    const payloadTemp = action.payload.map((el: any) => {
      const elTemp = {
        ...el,
        entitlement_id: el.entitlementId,
        identitySystemId:
          IDENTITY_SYSTEM[
            el.identity_system_id as keyof typeof IDENTITY_SYSTEM
          ],
      };
      delete elTemp.entitlementId;
      return elTemp;
    });
    return compose(
      immutableSet([EMERGENCY_USER_LIST, LOADER_IDENTIFIER], false),
      immutableSet([EMERGENCY_USER_LIST, LIST_IDENTIFIER], payloadTemp)
    )(state);
  },

  [actionTypes.EMERGENCY_REQUEST_LIST_REQUEST]: (state: any, action: IAction) =>
    immutableSet([EMERGENCY_USER_LIST, LOADER_IDENTIFIER], true, state),

  [actionTypes.EMERGENCY_REQUEST_LIST_FAILURE]: (state: any, action: IAction) =>
    immutableSet([EMERGENCY_USER_LIST, LOADER_IDENTIFIER], false, state),

  [actionTypes.CREATE_REQUEST_EMERGENCY_USER]: (state: any, action: IAction) =>
    immutableSet([DETAIL, CALL_STATE], IResponseState.PENDING, state),

  [actionTypes.CREATE_REQUEST_EMERGENCY_USER_SUCCESS]: (
    state: any,
    action: IAction
  ) => immutableSet([DETAIL, CALL_STATE], IResponseState.SUCCESS, state),

  [actionTypes.CREATE_REQUEST_EMERGENCY_USER_FAILURE]: (
    state: any,
    action: IAction
  ) => immutableSet([DETAIL, CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.SELECT_USER]: (state: any, action: IAction) =>
    immutableSet([DETAIL, USER], action.payload, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
